import { parseApiDate } from './parseApiDate';

export function fullDateTime(iso) {
  if (!iso) return '';
  const d = parseApiDate(iso);
  if (!d || Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    timeZoneName: 'short',
  });
}
